import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names (clsx) and de-conflict Tailwind utilities (tailwind-merge). The standard
 * class-merge helper. Standardize on `cn`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
